import * as z from "zod";

// Basic schema for a single amount value
const singleAmountSchema = z.coerce.number().min(0, { message: "validation:amountMustBePositive" });

// For handling a single amount (used in simple cases)
export const FinalAmountValidationSchema = z.object({
  amount: singleAmountSchema,
});

// For handling multiple amounts with dynamic keys based on order IDs
export const MultipleFinalAmountValidationSchema = z.record(z.string(), singleAmountSchema);

// Type for a single amount form
export type FinalAmountFormInput = z.infer<typeof FinalAmountValidationSchema>;

// Type for multiple amounts form
export type MultipleFinalAmountFormInput = z.infer<typeof MultipleFinalAmountValidationSchema>;
